import React, { useState, useEffect } from "react";
import "./Jobs.css";
import CategoriesNav from "../categoriesNav/categoriesNav";
import { fetchData } from "../../Api/dataApi";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Job = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const truncateText = (text, wordLimit) => {
    if (!text) return "";
    const words = text.split(" ");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  };

  useEffect(() => {
    const fetchJob = async () => {
      try {
        const result = await fetchData("Job");
        setData(result);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchJob();
  }, []);

  return (
    <div className="Job">
      <CategoriesNav />
      <h2 className="Job-title">{t("available_jobs")}</h2>

      {loading && <p>{t("loading")}</p>}
      {error && (
        <p style={{ color: "red" }}>
          {t("error_message")}: {error}
        </p>
      )}

      <div className="Job-container">
        {data.length === 0 && !loading && <p>{t("no_product")}</p>}

        {data.map((job) => (
          <div key={job.id || job._id} className="Job-card">
            <Link to={`/product/${job.id || job._id}`}>
              <img
                src={
                  Array.isArray(job.images) && job.images.length > 0
                    ? job.images[0]
                    : t("no_image")
                }
                alt={job.title || t("no_name")}
                className="Job-image"
              />
            </Link>
            <div className="Job-content">
              <h3 className="job-name">
                {truncateText(job.title || t("no_name"), 6)}
              </h3>
              <p className="job-description">
                {truncateText(job.description || t("no_description"), 6)}
              </p>
              <p className="job-price">
                {t("price")}: {job.price || t("no_price")}
              </p>
              <p className="job-location">
                {t("location")}: {job.location || t("no_location")}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Job;
